import {useCompanySettings} from "../../hooks/useCompanySettings";
import { useInstrument } from "../../hooks/useInstruments";
import i18n from "@euroland/libs/locale/i18n";
import { classNames, replaceKey } from "../../utils";
import { formatDate } from "@euroland/libs/utils/formatDate";
import TickerName from "../TickerName";
import Icon from "../ui/Icon";

export default function TickerArea() {
  const [{ selectedInstrument }] = useInstrument();
  const settings = useCompanySettings();
  if (!selectedInstrument.ticker) return null;
  const dateTime = selectedInstrument.lastUpdatedDate;
  const isOpen = selectedInstrument.marketStatus === 'Open';
  let isLongDate = true;
  const label = "updatedOn";
  const lastUpdated = replaceKey(i18n.translate(label), [formatDate(dateTime, 'longDate')]);

  return (
    <>
      <header className="ticker-area">
        <p className="ticker-names">
          <TickerName shareName={selectedInstrument.shareName} marketAbbreviation={selectedInstrument.marketAbbreviation} />
          {selectedInstrument?.isRT && (
            <p className={classNames('ticker-area__real-time', { close: !isOpen })}>
              {isOpen ? <Icon name='checked-radio' className='checked-radio' /> : <Icon name='close-radio' className='close-radio' />}
              <span className="ticker-area__real-time-label"> {i18n.translate('realTimeData')}</span>
            </p>
          )}
        </p>
        {!!dateTime && (
          <cite className="last-trades">
            {" "}
            {lastUpdated}
          </cite>
        )}
      </header>
    </>
  );
}
